// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import FadeTransitionState from '../../animationpack/state/FadeTransitionState';

/**
 * A transition that blends over a given time from one animation state to another, synchronizing the target state to the initial state's start time. This is best used with two clips that have similar motions.
 */
class SyncFadeTransitionState extends FadeTransitionState {
  constructor() {
    super();
  }

  resetClips(globalTime) {
    super.resetClips(globalTime);
    this._targetState.resetClips(this._sourceState._globalStartTime);
  }

  shiftClipTime(shiftTime) {
    super.shiftClipTime(shiftTime);
    this._targetState.shiftClipTime(this._sourceState._globalStartTime + shiftTime);
    this._sourceState.shiftClipTime(shiftTime);
  }
}

export default SyncFadeTransitionState;
